import * as ActionTypes from './actionTypes';

const initialState = {
  all: [],
  search: '',
};

export default function verificationReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PUT_PENDING_USERS: {
      const existingIds = new Set(state.all.map(u => u._id));
      const newUsers = action.users.filter(u => !existingIds.has(u._id));
      const updatedExisting = state.all.map(existing => {
        const updated = action.users.find(u => u._id === existing._id);
        return updated || existing;
      });
      return {
        ...state,
        all: [...updatedExisting, ...newUsers],
      };
    }
    case ActionTypes.REMOVE_PENDING_USER:
      return {
        ...state,
        all: state.all.filter(u => u._id !== action.id),
      };
    case ActionTypes.SET_VERIFICATION_SEARCH:
      return {
        ...state,
        search: action.search,
      };
    default:
      return state;
  }
}
